export default __webpack_public_path__ + "static/media/type-2.f7eedace.svg";